import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stationSearchActions from '../stationSearch/stationSearchActions';
import StationSearchResults from './StationSearchResults';
import i18n from 'i18next';
import translations from "../translations";

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class StationSearchResultsContainer extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.actions.clearStationSearch();
  }

  render() {
    let body;

    if(this.props.loading) {
      body = (
        <div className="text-center" style={{paddingBottom: 15}}>
          <br />
          <br />
          {i18n.t('stationSearchResults.loading')}
        </div>
      );
    } else if(this.props.error) {
      body = (
        <div>
          {i18n.t('stationSearchResults.error')}
        </div>
      );
    } else if(this.props.query_performed && !this.props.has_matches) {
      body = (
        <div style={{padding: 12}}>
          {i18n.t('stationSearchResults.no_matches')}
        </div>
      );
    } else {
      body = (
        <div>
          { this.props.with_scheduled_service_stations.length > 0 &&
            <StationSearchResults header={this.props.withScheduledServiceHeader}
              stations={this.props.with_scheduled_service_stations}
              selectResult={this.props.selectResult} />  
          }
          {  this.props.suggested_stations.length > 0 &&
            <StationSearchResults header={this.props.suggestedHeader}
              stations={this.props.suggested_stations}
              selectResult={this.props.selectResult} />
          }
          {
            this.props.searchInput &&
            <StationSearchResults header={(this.props.suggested_stations.length > 0 || this.props.with_scheduled_service_stations.length > 0) ? i18n.t('stationSearchResults.all') : ""} 
              stations={this.props.stations} start="0" take="10" 
              selectResult={this.props.selectResult} />
            }
        </div>
      );
    }

    return body;
  }
}

function mapStateToProps(state, ownProps) {
  var filterStations = (stations) => {
    var code = ownProps.oppositeDirectionCode;
    if (code) {
      return stations.filter(s => s.code !== code);
    } else {
      return stations;
    }
  };

  return {
    stations: state.stationSearch.stations,
    suggested_stations: filterStations(state.stationSearch.suggested_stations),
    with_scheduled_service_stations: filterStations(state.stationSearch.with_scheduled_service_stations),
    query_performed: state.stationSearch.query_performed,
    has_matches: state.stationSearch.has_matches,
    loading: state.stationSearch.loading,
    error: state.stationSearch.error
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(stationSearchActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StationSearchResultsContainer)
